module.exports = __webpack_public_path__ + "img/Website.79921e16.jpg";